import React, { useState, useCallback } from 'react';
import Modal from '@/components/Modals/Modal'; // Adjust path to Modal
import styles from './ArticleActionBar.module.scss'; // SCSS module
import { ComponentProps } from 'lib/component-props';
import { usePageData } from 'lib/page-data/PageDataContext';
import useHelpers from 'hooks/helpers';
import { useI18n } from 'next-localization';
import ShareModalContent from 'components/Modals/ShareModalContent';

const ArticleActionBar: React.FC<ComponentProps> = ({ rendering }) => {
  const { localizeDate } = useHelpers();
  const { t } = useI18n();
  const { articleData } = usePageData('article') ?? {};
  const [showShareModal, setShowShareModal] = useState<boolean>(false);

  const toggleModal = useCallback(() => setShowShareModal((prev) => !prev), []);

  const duration = articleData?.duration?.value ?? 0;
  const durationText =
    duration > 0 ? `Duration: ${duration} ${duration > 1 ? 'mins' : 'min'}` : null;

  return (
    articleData && (
      <section
        id={rendering.uid}
        data-e2e-component-uid={rendering.uid}
        className={`w-100 ${styles.wrapper} py-3`}
      >
        <div className="container d-flex flex-column flex-md-row justify-content-between">
          <div className="left-side d-flex flex-column flex-md-row justify-content-between justify-content-md-start">
            {articleData.articleSeries?.targetItem?.url && (
              <div className="d-flex align-items-center body-small me-5 mb-2 mb-md-0 url-print">
                <p>Part of the series: {articleData.articleSeriesPart?.value}&nbsp;</p>
                <p>{articleData.articleSeries.targetItem.name.value}</p>
              </div>
            )}

            <div className="d-flex">
              {articleData.articlePublicationDate.formattedDateValue && (
                <>
                  {durationText && (
                    <p className="d-flex align-items-center body-small me-5 duration-print">
                      {durationText}
                    </p>
                  )}
                  <p className="d-flex align-items-center body-small date-print">
                    Date: {localizeDate(articleData.articlePublicationDate.formattedDateValue)}
                  </p>
                </>
              )}
            </div>
          </div>

          {articleData.articlePublicationDate.formattedDateValue && (
            <div className="right-side d-flex justify-content-between justify-content-md-start mt-2 mt-md-0">
              <button
                type="button"
                aria-label="Open modal"
                className={`d-flex gap-1 align-items-center text-link share btn-naked`}
                onClick={toggleModal}
              >
                {t('share')}
                <i className="bi bi-share" aria-hidden={true} />
              </button>
              <Modal
                renderContent={showShareModal}
                isModalOpen={showShareModal}
                aria-label={t('shareThisArticle')}
                onCloseModal={toggleModal}
              >
                <ShareModalContent onCloseModal={toggleModal} />
              </Modal>
            </div>
          )}
        </div>
      </section>
    )
  );
};

export default ArticleActionBar;
